module.exports = __webpack_public_path__ + "img/ic-walletconnect.35e0a5ef.svg";